<template>
  <div class="product-review" v-on:mouseleave="mouseleave">
    <div class="wrapper">
      <div class="container container-product-review">
        <div class="row">
          <div class="col-12">
            <a
              v-bind:href="getHrefLink()"
              class="resmed-brand logo-redirect"
              target="_blank"
            ></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utility from "./utility";
import debounce from "lodash/debounce";
import wpApi from "../../services/wpApi";

export default {
  name: "product-review",
  components: {
    utility,
  },
  data() {
    return {
      searchActive: false,
      search: "text-icon", // xhr get request on create method
      reversed: false,
      sticky: {
        active: false,
        allowed: false,
        direction: "",
        i: 0,
      },
      promos: [],
      items: [],
    };
  },
  methods: {
    getHrefLink() {
      let hrefLink = "/sleep-apnea/";
      let urlLocation = window.location.href;
      let urls = [
        { urlContain: "/sleep-apnea/", redirectTo: "/sleep-apnea/" },
        { urlContain: "/portable-oxygen/", redirectTo: "/portable-oxygen/" },
        { urlContain: "/ventilation/", redirectTo: "/ventilation/" },
      ];
      urls.forEach((element) => {
        if (urlLocation.indexOf(element.urlContain) !== -1) {
          hrefLink = element.redirectTo;
        }
      });
      return hrefLink;
    },
    toggleSearch() {
      bus.$emit("hamburger:mobile-search", !this.searchActive);
      bus.$emit("hamburger:active", false);
    },
    mouseleave() {
      bus.$emit("navigation:mouseleave", true);
    },
    debounce: debounce(function () {
      this.sticky.allowed = window.scrollY > 200; // threshold

      this.sticky.direction =
        document.body.getBoundingClientRect().top > this.sticky.i
          ? "up"
          : "down";
      this.sticky.i = document.body.getBoundingClientRect().top;

      if (this.sticky.allowed && this.sticky.direction === "up") {
        this.sticky.active = true;
      } else {
        if (this.sticky.allowed) {
          // transition allowed
          clearTimeout(out);

          // delay: keep active `true` until transition-out has finished
          let out = setTimeout(() => {
            this.sticky.active = false;
          }, 600); // 100ms shy of animation
        } else {
          // no transition
          this.sticky.active = false;
        }
      }
    }, 60),
  },
  created() {
    let arr = location.pathname.split("/").filter(function (e) {
        return e;
      }),
      site = arr[1];

    // is valid site, or 404
    let valid = ["sleep-apnea", "portable-oxygen", "ventilation"].some((e) => {
      return e === site;
    });

    if (arr.length && valid) {
      wpApi.getHeaderPromos(site)
        .then((response) => {
          if (
            site === "sleep-apnea" ||
            site === "ventilation" ||
            site === "portable-oxygen"
          ) {
            for (let value of response.data) {
              let obj = {},
                match = [];

              obj.name = value.name
                .replace(/(.*)(?:\(.*\))|(?:\[.*\])/g, "$1")
                .trim();
              obj.href = value.href;
              obj.target = value.target;

              match = value.name.match(/\[(.*)\]/gi); // not sure whay group 1 is not match
              obj.cta = match[0].replace(new RegExp(/\[|\]/, "g"), "");

              match = value.name.match(/\((.*)\)/gi);
              if (match !== null) {
                obj.intro = match[0].replace(new RegExp(/\(|\)/, "g"), "");
              }

              this.promos.push(obj);
            }
          }
        });

      wpApi.getHeaderNavigation(site)
        .then((response) => {
          if (
            site === "sleep-apnea" ||
            site === "ventilation" ||
            site === "portable-oxygen"
          ) {
            response.data.shift();
            this.items = response.data;
          }
        });
    } else {
      // index (consumers)
      this.items = [
        { name: "Sleep Apnea", href: "/sleep-apnea/" },
        { name: "Portable Oxygen", href: "/portable-oxygen/" },
        { name: "Ventilation", href: "/ventilation/" },
        {
          name: "I’m a Healthcare Professional",
          href: "https://www.resmed.com/us/en/healthcare-professional.html?utm_source=rmd&utm_medium=b2c-website",
        },
      ];
    }

    // sticky nav
    window.addEventListener("scroll", () => {
      this.debounce();
    });

    // get_field `nav-search-icon`
    wpApi.get("get-field/nav-search-icon/87")
      .then((response) => {
        this.search = response.data;
      });

    bus.$on("navigation:reversed", (arg) => {
      this.reversed = arg;
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";
.product-review {
  position: relative;
  z-index: 101;
  .is-sticky {
    position: fixed;
    top: 0;
    left: 0;
    background-color: $cc-resmed-white;
    &.transition-allowed {
      &.transition-in {
        animation: sticky-transition-in 0.5s;
        animation-fill-mode: forwards;
      }
      &.transition-out {
        animation: sticky-transition-out 700ms ease;
      }
    }
  }
  .resmed-brand {
    display: block;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    background-image: url(#{$assets}/images/logo-text-color.png);
  }
  @media (max-width: 767px) {
    background-color: #f8f8f8;
    padding: 25px 0px 25px 0px;
    .resmed-brand {
      margin: 0 auto;
      width: 66px;
      height: 49.1px;
    }
  }
  /* Small devices (tablets, 768px and up) */
  @media (min-width: 768px) {
    padding: 25px 0px 25px 0px;

    .resmed-brand {
      margin: 0 auto;
    }
  }

  /* Medium devices (desktops, 992px and up) */
  @media (min-width: 992px) {
    padding: 30px 0px 30px 0px;
    .resmed-brand {
      margin: 0px;
      width: 82px;
      height: 61px;
    }
    .container-product-review {
      padding-left: 160px;
      margin-left: 0px;
      padding-right: 160px;
      margin-right: 0px;
    }
  }
  /* Large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
  }
  @media (min-width: 768px) and (max-width: 991px) {
    .resmed-brand {
      margin: 0 auto;
      width: 150px;
      height: 103px;
      background-size: 100px;
    }
  }
  @keyframes sticky-transition-in {
    0% {
      transform: translateY(-160px);
      opacity: 0.25;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
  @keyframes sticky-transition-out {
    0% {
      transform: translateY(0);
      opacity: 1;
    }
    100% {
      transform: translateY(-160px);
      opacity: 0;
    }
  }
}
</style>